import i18n from "@/i18n";
import moment from "moment";

export const emailNum = function () {
  return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
};

export const ApiLanguage = function () {
  const language =
    ["ZH_HANT", "PT", "EN"][["zh-TW", "pt", "en"].indexOf(i18n.locale)] ||
    "ZH_HANT";
  return language;
};

export const isZHHANT = function () {
  console.log(i18n.locale.toUpperCase());
  if (i18n.locale.toUpperCase() === "ZH-HANT") {
    return true;
  }
  return false;
};

export const differYear = (
  startDate,
  endDate,
  precision = false,
  diffFormat = "day"
) => {
  if (!startDate || !endDate) return 0; // 未填寫開始/結束日期處理
  return moment(endDate).diff(moment(startDate), diffFormat, precision);
};
export const getNowTime = (format = "YYYY/MM/DD") => {
  // 獲取當前時間
  return moment(new Date()).format(format);
};

export const dayFormat = function (value, format = "YYYY-MM-DD") {
  // 日期格式化
  if (!value) return;
  return moment(value).format(format);
};

//s:传入的float数字
export const fmoney = function (s) {
  if (!s) {
    return `0.00`;
  }
  return new Intl.NumberFormat("zh-MO").format(s);
};


const getFilenameFromHeader = (header) => {
  if (!header) return null;
  let match = header.match(/filename="([^"]*)"/);
  if (match && match[1]) {
    return decodeURIComponent(match[1]);
  }

  // 匹配 filename=... 格式（不带引号）
  match = header.match(/filename=([^;]*)/);
  if (match && match[1]) {
    return decodeURIComponent(match[1].trim());
  }

  // 匹配 filename*=UTF-8''... 格式
  match = header.match(/filename\*=UTF-8''([^;]*)/);
  if (match && match[1]) {
    return decodeURIComponent(match[1]);
  }

  return null;
}


export const downloadFile = function (res) {
  // 下載文件
  let blobData = new Blob([res.data], { type: "application/pdf" });
  let fileName = getFilenameFromHeader(res.headers["content-disposition"])
  fileName = fileName ? decodeURI(fileName) : "download.pdf";
  let elink = document.createElement("a");
  elink.download = fileName;
  elink.href = URL.createObjectURL(blobData);
  elink.style.display = "none";
  document.body.appendChild(elink);
  elink.click();
  setTimeout(() => {
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  }, 100);
};

export const isAB = function () {
  return process.env.VUE_APP_THEME === "ab";
};
